import { render, staticRenderFns } from "./PartialCheckoutForm.vue?vue&type=template&id=bff36da8&scoped=true&"
import script from "./PartialCheckoutForm.vue?vue&type=script&lang=js&"
export * from "./PartialCheckoutForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff36da8",
  null
  
)

export default component.exports